import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Download, FileText } from "lucide-react";

export function EmployeePayslipsDialog({ employee, companyId, onClose }) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!employee) return;
    (async () => {
      setLoading(true);
      try {
        const r = await apiClient.get(`/companies/${companyId}/employees/${employee._id}/payslips`);
        setItems(r.data || []);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [employee, companyId]);

  const download = async (p) => {
    try {
      const res = await apiClient.get(`/companies/${companyId}/payslips/${p.id}/file`, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: "application/pdf" }));
      const a = document.createElement("a");
      a.href = url;
      a.download = p.file_name || `Lohnabrechnung_${p.period}.pdf`;
      document.body.appendChild(a); a.click(); document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Dialog open={!!employee} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid="employee-payslips-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-emerald-700" />
            Lohnabrechnungen — {employee?.first_name} {employee?.last_name}
          </DialogTitle>
        </DialogHeader>
        {loading ? (
          <div className="text-sm text-slate-400 py-4">Lade…</div>
        ) : items.length === 0 ? (
          <div className="text-sm text-slate-400 py-4" data-testid="payslips-empty">
            Noch keine archivierten Lohnabrechnungen — sie werden automatisch abgelegt, sobald ein
            Lohnlauf gebucht wird.
          </div>
        ) : (
          <div className="space-y-1.5 max-h-[50vh] overflow-y-auto">
            {items.map((p) => (
              <div key={p.id} className="flex items-center justify-between rounded-md border border-slate-200 px-3 py-2" data-testid={`payslip-item-${p.id}`}>
                <div>
                  <div className="text-sm font-medium">{p.period}</div>
                  <div className="text-xs text-slate-500">
                    Netto CHF {Number(p.net_salary || 0).toFixed(2)}
                    {p.emailed_to && (
                      <Badge variant="outline" className="ml-2 text-[10px] text-emerald-700 border-emerald-300">
                        gemailt
                      </Badge>
                    )}
                  </div>
                </div>
                <Button variant="outline" size="sm" onClick={() => download(p)} title="PDF herunterladen" data-testid={`payslip-download-${p.id}`}>
                  <Download className="h-3.5 w-3.5 mr-1" />
                  PDF
                </Button>
              </div>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
